import React from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Cell,
} from 'recharts';

const BUCKET_COLORS = ['#22c55e', '#eab308', '#f97316', '#ef4444']; // green → red

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const data = payload[0].payload;

  return (
    <div className="bg-white border rounded-lg shadow-lg p-3 text-sm">
      <p className="font-medium text-gray-700">{data.label}</p>
      <p className="text-gray-600">{data.quantity} units</p>
      <p className="text-gray-400">{data.count} inventory record{data.count !== 1 ? 's' : ''}</p>
    </div>
  );
};

const StockAgingChart = ({ buckets }) => {
  if (!buckets || buckets.length === 0 || buckets.every((b) => b.quantity === 0)) {
    return (
      <p className="text-sm text-gray-400 text-center py-6">
        No inventory data for aging analysis
      </p>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={220}>
      <BarChart data={buckets} margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
        <XAxis dataKey="label" tick={{ fontSize: 11 }} />
        <YAxis tick={{ fontSize: 11 }} />
        <Tooltip content={<CustomTooltip />} />
        <Bar dataKey="quantity" radius={[4, 4, 0, 0]}>
          {buckets.map((_, i) => (
            <Cell key={i} fill={BUCKET_COLORS[i] || BUCKET_COLORS[3]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default StockAgingChart;
